module.exports = __webpack_public_path__ + "assets/sushi-f6f958.svg";